import { EventBusForThirdParty } from '../event-bus'
import { handleEveryPageView } from './default/handle-every-page-view'
import { handlePublishDeveloperReports } from './default/handle-publish-developer-reports'
import { handlePurchaseSubscription } from './default/handle-purchase-subscription'
import { EventSubscriptionFacade } from './facade'
import { handleCartViewEvent } from './hotellovers/handle-cart-view'
import { handlePageInitializedEvent } from './hotellovers/handle-page-initialized'
import { handleProductDetailViewEventOld } from './hotellovers/handle-product-detail-view-old'
import { handlePurchase } from './hotellovers/handle-purchase'
import { handleLoginEvent } from './shared/handle-login'
import { handleSignupEvent } from './shared/handle-signup'

export class HotelloversEventSubscriptionFacade implements EventSubscriptionFacade {
  constructor() {
    /** GAで使用するdataLayerがundefinedでないことを保証する。 */
    window.dataLayer = window.dataLayer || []
  }

  subscribeAll(): void {
    const eventBus = EventBusForThirdParty.getInstance()
    eventBus.subscribe('signup', handleSignupEvent)
    eventBus.subscribe('login', handleLoginEvent)
    eventBus.subscribe('every-page-view', handleEveryPageView)
    /**
     * 止血対応として一時的にGA4推奨形式のイベント送信を停止
     * @see https://github.com/Everforth/growthpalette-front/issues/8606#issuecomment-3924614215
     */
    // eventBus.subscribe('product-detail-view', handleProductDetailViewEventForGA4)
    eventBus.subscribe('product-detail-view', handleProductDetailViewEventOld)
    // eventBus.subscribe('product-detail-color-selection', handleProductDetailColorSelectionEventForGA4)
    eventBus.subscribe('cart-view', handleCartViewEvent)
    eventBus.subscribe('purchase', handlePurchase)
    eventBus.subscribe('purchase-subscription', handlePurchaseSubscription)
    eventBus.subscribe('publish-developer-reports', handlePublishDeveloperReports)
    eventBus.subscribe('page-initialized', handlePageInitializedEvent)
  }
}
